import { render, staticRenderFns } from "./supplier-detail.vue?vue&type=template&id=11531a71"
import script from "./supplier-detail.vue?vue&type=script&lang=js"
export * from "./supplier-detail.vue?vue&type=script&lang=js"
import style0 from "./supplier-detail.vue?vue&type=style&index=0&id=11531a71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports